module.exports = __webpack_public_path__ + "static/netflixlogo-ae0d9c94024fc8e5478caf2a4224ec42.png";